import React from "react";
import Icon from "../../../components/AppIcon";

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-8">
      {categories?.map((category) => (
        <button
          key={category?.id}
          onClick={() => onCategoryChange(category?.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
            activeCategory === category?.id
              ? "bg-primary text-white shadow-md"
              : "bg-muted text-text-secondary hover:bg-primary/10 hover:text-primary"
          }`}
        >
          <Icon name={category?.icon} size={15} />
          <span>{category?.name}</span>
          <span
            className={`text-xs px-1.5 py-0.5 rounded-full ${
              activeCategory === category?.id
                ? "bg-white/20 text-white"
                : "bg-border text-text-secondary"
            }`}
          >
            {category?.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
